import React from 'react';
import { Link } from 'react-router-dom';

const BackofficeModuleTabs = ({ tabs = [], activeModule, onChange }) => (
  <nav className="module-tabs" aria-label="Backoffice modules">
    {tabs.map((tab) => {
      const children = Array.isArray(tab.children) ? tab.children : [];

      if (children.length > 0) {
        return (
          <details className="module-tab-menu" key={tab.key}>
            <summary className={`module-tab ${activeModule === tab.key ? 'active' : ''}`}>
              <span>{tab.label}</span>
              <i className="bi bi-chevron-down" aria-hidden="true"></i>
            </summary>
            <div className="module-tab-dropdown">
              {children.map((item) => (
                <Link key={item.key || item.to} className="module-tab-dropdown-link" to={item.to}>
                  {item.label}
                </Link>
              ))}
            </div>
          </details>
        );
      }

      return tab.to ? (
        <Link key={tab.key} className="module-tab" to={tab.to}>
          {tab.label}
        </Link>
      ) : (
        <button
          key={tab.key}
          type="button"
          className={`module-tab ${activeModule === tab.key ? 'active' : ''}`}
          onClick={() => onChange?.(tab.key)}
        >
          {tab.label}
        </button>
      );
    })}
  </nav>
);

export default BackofficeModuleTabs;
